module.exports = __webpack_public_path__ + "static/img/bg-tr.4bb275fe.png";